import React from 'react';
import { Link } from 'react-router-dom';
import Nav from './Nav';
import Footer from './Footer';

function H2({ children }) {
  return <h2 style={{ fontSize: 17, fontWeight: 700, margin: '36px 0 10px', letterSpacing: '-.1px' }}>{children}</h2>;
}
function P({ children }) {
  return <p style={{ margin: '0 0 16px', color: 'var(--muted)' }}>{children}</p>;
}
function UL({ children }) {
  return <ul style={{ margin: '0 0 16px', paddingLeft: 20, color: 'var(--muted)' }}>{children}</ul>;
}
function LI({ children }) {
  return <li style={{ marginBottom: 8 }}>{children}</li>;
}

function Legal({ currentUser, currentUserProfile }) {
  const year = new Date().getFullYear();
  return (
    <>
      <Nav currentUser={currentUser} currentUserProfile={currentUserProfile} />
      <div style={{ maxWidth: 680, margin: '0 auto', padding: '48px 20px 80px' }}>
        <Link to="/" style={{ fontSize: 13, color: 'var(--muted)', textDecoration: 'none', display: 'inline-block', marginBottom: 32 }}>
          ← Back
        </Link>
        <h1 style={{ fontSize: 26, fontWeight: 800, letterSpacing: '-.3px', marginBottom: 6 }}>Legal</h1>
        <p style={{ color: 'var(--muted)', fontSize: 13, marginBottom: 40 }}>
          Last updated: June 15, 2026
        </p>
        <div style={{ color: 'var(--text)', lineHeight: 1.75, fontSize: 15 }}>
          <H2>Trademarks</H2>
          <P>
            Your Top 8™ and the Your Top 8 "8" logo are trademarks of Your Top 8. You may not
            use these names, logos, badges, or brand assets in a way that suggests affiliation,
            sponsorship, endorsement, or official partnership without prior written permission.
            You may use the name Your Top 8 only to refer accurately to the service.
          </P>
          <P>
            Your Top 8 is an independent service. It is not affiliated with, endorsed by, or
            sponsored by Myspace, Meta, or any other social network. Any other names, logos,
            trademarks, or brands referenced on the service belong to their respective owners.
          </P>

          <H2>Copyright</H2>
          <P>
            © {year} Your Top 8. All rights reserved.
          </P>
          <P>
            The original design, layout, code, graphics, logos, badge designs, written copy, and
            other original content of the Your Top 8 website and app are protected by copyright
            and other applicable laws. You may not copy, reproduce, modify, distribute, or use
            them to create a competing or confusingly similar service without permission.
          </P>
          <P>
            Content you submit remains yours, as described in the{' '}
            <Link to="/terms">Terms of Service</Link>.
          </P>

          <H2>Reporting and Takedowns</H2>
          <P>
            To report content that infringes your copyright or trademark, violates your privacy or
            publicity rights, impersonates you, uses your name, image, or contact information
            without permission, or otherwise violates our Terms, email{' '}
            <a href="mailto:legal@yourtop8.com">legal@yourtop8.com</a> with enough detail for us to
            identify the content and review your claim.
          </P>
          <P>Please include:</P>
          <UL>
            <LI>Your name and contact information.</LI>
            <LI>A link or description identifying the content.</LI>
            <LI>A short explanation of your concern.</LI>
            <LI>Any information that helps us verify your claim.</LI>
          </UL>
          <P>We review every report and may remove or restrict content when appropriate.</P>

          <H2>Contact</H2>
          <P>
            For trademark, copyright, privacy, impersonation, takedown, or other legal questions,
            email <a href="mailto:legal@yourtop8.com">legal@yourtop8.com</a>.
          </P>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Legal;
